export enum BorrowersColumnSizes {
  Name = 23,
  IdNumber = 11,
  Phone = 13,
  Email = 19,
  CreatedAt = 17,
  UpdatedAt = 17,
}
